// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file customer/management/v1/service.proto (package customer.management.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file customer/management/v1/service.proto.
 */
export const file_customer_management_v1_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * @generated from message customer.management.v1.GetAPIKeyFromAccessTokenRequest
 */
export type GetAPIKeyFromAccessTokenRequest = Message<"customer.management.v1.GetAPIKeyFromAccessTokenRequest"> & {
  /**
   * @generated from field: string access_key = 1;
   */
  accessKey: string;
};

/**
 * Describes the message customer.management.v1.GetAPIKeyFromAccessTokenRequest.
 * Use `create(GetAPIKeyFromAccessTokenRequestSchema)` to create a new message.
 */
export const GetAPIKeyFromAccessTokenRequestSchema: GenMessage<GetAPIKeyFromAccessTokenRequest> = /*@__PURE__*/
  messageDesc(file_customer_management_v1_service, 0);

/**
 * @generated from message customer.management.v1.GetAPIKeyFromAccessTokenResponse
 */
export type GetAPIKeyFromAccessTokenResponse = Message<"customer.management.v1.GetAPIKeyFromAccessTokenResponse"> & {
  /**
   * @generated from field: string session_jwt = 1;
   */
  sessionJwt: string;
};

/**
 * Describes the message customer.management.v1.GetAPIKeyFromAccessTokenResponse.
 * Use `create(GetAPIKeyFromAccessTokenResponseSchema)` to create a new message.
 */
export const GetAPIKeyFromAccessTokenResponseSchema: GenMessage<GetAPIKeyFromAccessTokenResponse> = /*@__PURE__*/
  messageDesc(file_customer_management_v1_service, 1);

/**
 * @generated from message customer.management.v1.GetUserByIdRequest
 */
export type GetUserByIdRequest = Message<"customer.management.v1.GetUserByIdRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * Describes the message customer.management.v1.GetUserByIdRequest.
 * Use `create(GetUserByIdRequestSchema)` to create a new message.
 */
export const GetUserByIdRequestSchema: GenMessage<GetUserByIdRequest> = /*@__PURE__*/
  messageDesc(file_customer_management_v1_service, 2);

/**
 * @generated from message customer.management.v1.GetUserByIdResponse
 */
export type GetUserByIdResponse = Message<"customer.management.v1.GetUserByIdResponse"> & {
  /**
   * @generated from field: customer.management.v1.User user = 1;
   */
  user?: User;
};

/**
 * Describes the message customer.management.v1.GetUserByIdResponse.
 * Use `create(GetUserByIdResponseSchema)` to create a new message.
 */
export const GetUserByIdResponseSchema: GenMessage<GetUserByIdResponse> = /*@__PURE__*/
  messageDesc(file_customer_management_v1_service, 3);

/**
 * @generated from message customer.management.v1.RemoveUserFromTenantRequest
 */
export type RemoveUserFromTenantRequest = Message<"customer.management.v1.RemoveUserFromTenantRequest"> & {
  /**
   * @generated from field: string login_id = 1;
   */
  loginId: string;
};

/**
 * Describes the message customer.management.v1.RemoveUserFromTenantRequest.
 * Use `create(RemoveUserFromTenantRequestSchema)` to create a new message.
 */
export const RemoveUserFromTenantRequestSchema: GenMessage<RemoveUserFromTenantRequest> = /*@__PURE__*/
  messageDesc(file_customer_management_v1_service, 4);

/**
 * @generated from message customer.management.v1.RemoveUserFromTenantResponse
 */
export type RemoveUserFromTenantResponse = Message<"customer.management.v1.RemoveUserFromTenantResponse"> & {
};

/**
 * Describes the message customer.management.v1.RemoveUserFromTenantResponse.
 * Use `create(RemoveUserFromTenantResponseSchema)` to create a new message.
 */
export const RemoveUserFromTenantResponseSchema: GenMessage<RemoveUserFromTenantResponse> = /*@__PURE__*/
  messageDesc(file_customer_management_v1_service, 5);

/**
 * @generated from message customer.management.v1.ListUsersRequest
 */
export type ListUsersRequest = Message<"customer.management.v1.ListUsersRequest"> & {
};

/**
 * Describes the message customer.management.v1.ListUsersRequest.
 * Use `create(ListUsersRequestSchema)` to create a new message.
 */
export const ListUsersRequestSchema: GenMessage<ListUsersRequest> = /*@__PURE__*/
  messageDesc(file_customer_management_v1_service, 6);

/**
 * @generated from message customer.management.v1.ListUsersResponse
 */
export type ListUsersResponse = Message<"customer.management.v1.ListUsersResponse"> & {
  /**
   * @generated from field: repeated customer.management.v1.User users = 1;
   */
  users: User[];
};

/**
 * Describes the message customer.management.v1.ListUsersResponse.
 * Use `create(ListUsersResponseSchema)` to create a new message.
 */
export const ListUsersResponseSchema: GenMessage<ListUsersResponse> = /*@__PURE__*/
  messageDesc(file_customer_management_v1_service, 7);

/**
 * @generated from message customer.management.v1.User
 */
export type User = Message<"customer.management.v1.User"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: repeated string login_ids = 2;
   */
  loginIds: string[];

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string email = 4;
   */
  email: string;

  /**
   * @generated from field: customer.management.v1.UserStatus status = 5;
   */
  status: UserStatus;

  /**
   * @generated from field: optional string avatar_url = 6;
   */
  avatarUrl?: string;

  /**
   * @generated from field: string role = 7;
   */
  role: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message customer.management.v1.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User> = /*@__PURE__*/
  messageDesc(file_customer_management_v1_service, 8);

/**
 * @generated from message customer.management.v1.ListOrgsRequest
 */
export type ListOrgsRequest = Message<"customer.management.v1.ListOrgsRequest"> & {
};

/**
 * Describes the message customer.management.v1.ListOrgsRequest.
 * Use `create(ListOrgsRequestSchema)` to create a new message.
 */
export const ListOrgsRequestSchema: GenMessage<ListOrgsRequest> = /*@__PURE__*/
  messageDesc(file_customer_management_v1_service, 9);

/**
 * @generated from message customer.management.v1.ListOrgsResponse
 */
export type ListOrgsResponse = Message<"customer.management.v1.ListOrgsResponse"> & {
  /**
   * @generated from field: repeated string org_ids = 1;
   */
  orgIds: string[];
};

/**
 * Describes the message customer.management.v1.ListOrgsResponse.
 * Use `create(ListOrgsResponseSchema)` to create a new message.
 */
export const ListOrgsResponseSchema: GenMessage<ListOrgsResponse> = /*@__PURE__*/
  messageDesc(file_customer_management_v1_service, 10);

/**
 * @generated from message customer.management.v1.UpdateUserRoleRequest
 */
export type UpdateUserRoleRequest = Message<"customer.management.v1.UpdateUserRoleRequest"> & {
  /**
   * @generated from field: string login_id = 1;
   */
  loginId: string;

  /**
   * @generated from field: string role = 2;
   */
  role: string;
};

/**
 * Describes the message customer.management.v1.UpdateUserRoleRequest.
 * Use `create(UpdateUserRoleRequestSchema)` to create a new message.
 */
export const UpdateUserRoleRequestSchema: GenMessage<UpdateUserRoleRequest> = /*@__PURE__*/
  messageDesc(file_customer_management_v1_service, 11);

/**
 * @generated from message customer.management.v1.UpdateUserRoleResponse
 */
export type UpdateUserRoleResponse = Message<"customer.management.v1.UpdateUserRoleResponse"> & {
};

/**
 * Describes the message customer.management.v1.UpdateUserRoleResponse.
 * Use `create(UpdateUserRoleResponseSchema)` to create a new message.
 */
export const UpdateUserRoleResponseSchema: GenMessage<UpdateUserRoleResponse> = /*@__PURE__*/
  messageDesc(file_customer_management_v1_service, 12);

/**
 * @generated from message customer.management.v1.GetIntakeAllowedDomainsRequest
 */
export type GetIntakeAllowedDomainsRequest = Message<"customer.management.v1.GetIntakeAllowedDomainsRequest"> & {
};

/**
 * Describes the message customer.management.v1.GetIntakeAllowedDomainsRequest.
 * Use `create(GetIntakeAllowedDomainsRequestSchema)` to create a new message.
 */
export const GetIntakeAllowedDomainsRequestSchema: GenMessage<GetIntakeAllowedDomainsRequest> = /*@__PURE__*/
  messageDesc(file_customer_management_v1_service, 13);

/**
 * @generated from message customer.management.v1.GetIntakeAllowedDomainsResponse
 */
export type GetIntakeAllowedDomainsResponse = Message<"customer.management.v1.GetIntakeAllowedDomainsResponse"> & {
  /**
   * @generated from field: repeated string domains = 1;
   */
  domains: string[];
};

/**
 * Describes the message customer.management.v1.GetIntakeAllowedDomainsResponse.
 * Use `create(GetIntakeAllowedDomainsResponseSchema)` to create a new message.
 */
export const GetIntakeAllowedDomainsResponseSchema: GenMessage<GetIntakeAllowedDomainsResponse> = /*@__PURE__*/
  messageDesc(file_customer_management_v1_service, 14);

/**
 * @generated from message customer.management.v1.UpdateIntakeAllowedDomainsRequest
 */
export type UpdateIntakeAllowedDomainsRequest = Message<"customer.management.v1.UpdateIntakeAllowedDomainsRequest"> & {
  /**
   * @generated from field: repeated string domains = 1;
   */
  domains: string[];
};

/**
 * Describes the message customer.management.v1.UpdateIntakeAllowedDomainsRequest.
 * Use `create(UpdateIntakeAllowedDomainsRequestSchema)` to create a new message.
 */
export const UpdateIntakeAllowedDomainsRequestSchema: GenMessage<UpdateIntakeAllowedDomainsRequest> = /*@__PURE__*/
  messageDesc(file_customer_management_v1_service, 15);

/**
 * @generated from message customer.management.v1.UpdateIntakeAllowedDomainsResponse
 */
export type UpdateIntakeAllowedDomainsResponse = Message<"customer.management.v1.UpdateIntakeAllowedDomainsResponse"> & {
};

/**
 * Describes the message customer.management.v1.UpdateIntakeAllowedDomainsResponse.
 * Use `create(UpdateIntakeAllowedDomainsResponseSchema)` to create a new message.
 */
export const UpdateIntakeAllowedDomainsResponseSchema: GenMessage<UpdateIntakeAllowedDomainsResponse> = /*@__PURE__*/
  messageDesc(file_customer_management_v1_service, 16);

/**
 * @generated from message customer.management.v1.GenerateGitbookSSORequest
 */
export type GenerateGitbookSSORequest = Message<"customer.management.v1.GenerateGitbookSSORequest"> & {
  /**
   * return-to path within docs.lema.ai
   *
   * @generated from field: string location = 1;
   */
  location: string;
};

/**
 * Describes the message customer.management.v1.GenerateGitbookSSORequest.
 * Use `create(GenerateGitbookSSORequestSchema)` to create a new message.
 */
export const GenerateGitbookSSORequestSchema: GenMessage<GenerateGitbookSSORequest> = /*@__PURE__*/
  messageDesc(file_customer_management_v1_service, 17);

/**
 * @generated from message customer.management.v1.GenerateGitbookSSOResponse
 */
export type GenerateGitbookSSOResponse = Message<"customer.management.v1.GenerateGitbookSSOResponse"> & {
  /**
   * docs.lema.ai URL with signed jwt_token and location
   *
   * @generated from field: string redirect_url = 1;
   */
  redirectUrl: string;
};

/**
 * Describes the message customer.management.v1.GenerateGitbookSSOResponse.
 * Use `create(GenerateGitbookSSOResponseSchema)` to create a new message.
 */
export const GenerateGitbookSSOResponseSchema: GenMessage<GenerateGitbookSSOResponse> = /*@__PURE__*/
  messageDesc(file_customer_management_v1_service, 18);

/**
 * @generated from message customer.management.v1.ApiKey
 */
export type ApiKey = Message<"customer.management.v1.ApiKey"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string created_by_user_name = 3;
   */
  createdByUserName: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;

  /**
   * trailing chars of cleartext used for visual identification
   *
   * @generated from field: string key_suffix = 5;
   */
  keySuffix: string;
};

/**
 * Describes the message customer.management.v1.ApiKey.
 * Use `create(ApiKeySchema)` to create a new message.
 */
export const ApiKeySchema: GenMessage<ApiKey> = /*@__PURE__*/
  messageDesc(file_customer_management_v1_service, 19);

/**
 * @generated from message customer.management.v1.ListApiKeysRequest
 */
export type ListApiKeysRequest = Message<"customer.management.v1.ListApiKeysRequest"> & {
};

/**
 * Describes the message customer.management.v1.ListApiKeysRequest.
 * Use `create(ListApiKeysRequestSchema)` to create a new message.
 */
export const ListApiKeysRequestSchema: GenMessage<ListApiKeysRequest> = /*@__PURE__*/
  messageDesc(file_customer_management_v1_service, 20);

/**
 * @generated from message customer.management.v1.ListApiKeysResponse
 */
export type ListApiKeysResponse = Message<"customer.management.v1.ListApiKeysResponse"> & {
  /**
   * @generated from field: repeated customer.management.v1.ApiKey api_keys = 1;
   */
  apiKeys: ApiKey[];
};

/**
 * Describes the message customer.management.v1.ListApiKeysResponse.
 * Use `create(ListApiKeysResponseSchema)` to create a new message.
 */
export const ListApiKeysResponseSchema: GenMessage<ListApiKeysResponse> = /*@__PURE__*/
  messageDesc(file_customer_management_v1_service, 21);

/**
 * @generated from message customer.management.v1.CreateApiKeyRequest
 */
export type CreateApiKeyRequest = Message<"customer.management.v1.CreateApiKeyRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message customer.management.v1.CreateApiKeyRequest.
 * Use `create(CreateApiKeyRequestSchema)` to create a new message.
 */
export const CreateApiKeyRequestSchema: GenMessage<CreateApiKeyRequest> = /*@__PURE__*/
  messageDesc(file_customer_management_v1_service, 22);

/**
 * @generated from message customer.management.v1.CreateApiKeyResponse
 */
export type CreateApiKeyResponse = Message<"customer.management.v1.CreateApiKeyResponse"> & {
  /**
   * @generated from field: customer.management.v1.ApiKey api_key = 1;
   */
  apiKey?: ApiKey;

  /**
   * plaintext value — returned only at creation
   *
   * @generated from field: string cleartext = 2;
   */
  cleartext: string;
};

/**
 * Describes the message customer.management.v1.CreateApiKeyResponse.
 * Use `create(CreateApiKeyResponseSchema)` to create a new message.
 */
export const CreateApiKeyResponseSchema: GenMessage<CreateApiKeyResponse> = /*@__PURE__*/
  messageDesc(file_customer_management_v1_service, 23);

/**
 * @generated from message customer.management.v1.DeleteApiKeyRequest
 */
export type DeleteApiKeyRequest = Message<"customer.management.v1.DeleteApiKeyRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message customer.management.v1.DeleteApiKeyRequest.
 * Use `create(DeleteApiKeyRequestSchema)` to create a new message.
 */
export const DeleteApiKeyRequestSchema: GenMessage<DeleteApiKeyRequest> = /*@__PURE__*/
  messageDesc(file_customer_management_v1_service, 24);

/**
 * @generated from message customer.management.v1.DeleteApiKeyResponse
 */
export type DeleteApiKeyResponse = Message<"customer.management.v1.DeleteApiKeyResponse"> & {
};

/**
 * Describes the message customer.management.v1.DeleteApiKeyResponse.
 * Use `create(DeleteApiKeyResponseSchema)` to create a new message.
 */
export const DeleteApiKeyResponseSchema: GenMessage<DeleteApiKeyResponse> = /*@__PURE__*/
  messageDesc(file_customer_management_v1_service, 25);

/**
 * @generated from message customer.management.v1.McpConnection
 */
export type McpConnection = Message<"customer.management.v1.McpConnection"> & {
  /**
   * @generated from field: string app_name = 1;
   */
  appName: string;

  /**
   * When the user last granted the tool access: connecting the same tool again updates it.
   *
   * @generated from field: google.protobuf.Timestamp connected_at = 2;
   */
  connectedAt?: Timestamp;
};

/**
 * Describes the message customer.management.v1.McpConnection.
 * Use `create(McpConnectionSchema)` to create a new message.
 */
export const McpConnectionSchema: GenMessage<McpConnection> = /*@__PURE__*/
  messageDesc(file_customer_management_v1_service, 26);

/**
 * @generated from message customer.management.v1.ListMcpConnectionsRequest
 */
export type ListMcpConnectionsRequest = Message<"customer.management.v1.ListMcpConnectionsRequest"> & {
};

/**
 * Describes the message customer.management.v1.ListMcpConnectionsRequest.
 * Use `create(ListMcpConnectionsRequestSchema)` to create a new message.
 */
export const ListMcpConnectionsRequestSchema: GenMessage<ListMcpConnectionsRequest> = /*@__PURE__*/
  messageDesc(file_customer_management_v1_service, 27);

/**
 * @generated from message customer.management.v1.ListMcpConnectionsResponse
 */
export type ListMcpConnectionsResponse = Message<"customer.management.v1.ListMcpConnectionsResponse"> & {
  /**
   * @generated from field: repeated customer.management.v1.McpConnection connections = 1;
   */
  connections: McpConnection[];
};

/**
 * Describes the message customer.management.v1.ListMcpConnectionsResponse.
 * Use `create(ListMcpConnectionsResponseSchema)` to create a new message.
 */
export const ListMcpConnectionsResponseSchema: GenMessage<ListMcpConnectionsResponse> = /*@__PURE__*/
  messageDesc(file_customer_management_v1_service, 28);

/**
 * @generated from enum customer.management.v1.UserStatus
 */
export enum UserStatus {
  /**
   * @generated from enum value: USER_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: USER_STATUS_INVITED = 1;
   */
  INVITED = 1,

  /**
   * @generated from enum value: USER_STATUS_ENABLED = 2;
   */
  ENABLED = 2,

  /**
   * @generated from enum value: USER_STATUS_DISABLED = 3;
   */
  DISABLED = 3,
}

/**
 * Describes the enum customer.management.v1.UserStatus.
 */
export const UserStatusSchema: GenEnum<UserStatus> = /*@__PURE__*/
  enumDesc(file_customer_management_v1_service, 0);

/**
 * @generated from service customer.management.v1.CustomerManagementService
 */
export const CustomerManagementService: GenService<{
  /**
   * @generated from rpc customer.management.v1.CustomerManagementService.ListUsers
   */
  listUsers: {
    methodKind: "unary";
    input: typeof ListUsersRequestSchema;
    output: typeof ListUsersResponseSchema;
  },
  /**
   * @generated from rpc customer.management.v1.CustomerManagementService.RemoveUserFromTenant
   */
  removeUserFromTenant: {
    methodKind: "unary";
    input: typeof RemoveUserFromTenantRequestSchema;
    output: typeof RemoveUserFromTenantResponseSchema;
  },
  /**
   * @generated from rpc customer.management.v1.CustomerManagementService.GetUserById
   */
  getUserById: {
    methodKind: "unary";
    input: typeof GetUserByIdRequestSchema;
    output: typeof GetUserByIdResponseSchema;
  },
  /**
   * @generated from rpc customer.management.v1.CustomerManagementService.UpdateUserRole
   */
  updateUserRole: {
    methodKind: "unary";
    input: typeof UpdateUserRoleRequestSchema;
    output: typeof UpdateUserRoleResponseSchema;
  },
  /**
   * @generated from rpc customer.management.v1.CustomerManagementService.GetIntakeAllowedDomains
   */
  getIntakeAllowedDomains: {
    methodKind: "unary";
    input: typeof GetIntakeAllowedDomainsRequestSchema;
    output: typeof GetIntakeAllowedDomainsResponseSchema;
  },
  /**
   * @generated from rpc customer.management.v1.CustomerManagementService.UpdateIntakeAllowedDomains
   */
  updateIntakeAllowedDomains: {
    methodKind: "unary";
    input: typeof UpdateIntakeAllowedDomainsRequestSchema;
    output: typeof UpdateIntakeAllowedDomainsResponseSchema;
  },
  /**
   * Issue a GitBook-compatible JWT so authenticated Lema users can view docs.lema.ai
   *
   * @generated from rpc customer.management.v1.CustomerManagementService.GenerateGitbookSSO
   */
  generateGitbookSSO: {
    methodKind: "unary";
    input: typeof GenerateGitbookSSORequestSchema;
    output: typeof GenerateGitbookSSOResponseSchema;
  },
  /**
   * AI tools the calling user has connected to the Lema MCP in the current org.
   *
   * @generated from rpc customer.management.v1.CustomerManagementService.ListMcpConnections
   */
  listMcpConnections: {
    methodKind: "unary";
    input: typeof ListMcpConnectionsRequestSchema;
    output: typeof ListMcpConnectionsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_customer_management_v1_service, 0);

/**
 * @generated from service customer.management.v1.CustomerApiKeyService
 */
export const CustomerApiKeyService: GenService<{
  /**
   * @generated from rpc customer.management.v1.CustomerApiKeyService.GetAPIKeyFromAccessToken
   */
  getAPIKeyFromAccessToken: {
    methodKind: "unary";
    input: typeof GetAPIKeyFromAccessTokenRequestSchema;
    output: typeof GetAPIKeyFromAccessTokenResponseSchema;
  },
  /**
   * @generated from rpc customer.management.v1.CustomerApiKeyService.ListApiKeys
   */
  listApiKeys: {
    methodKind: "unary";
    input: typeof ListApiKeysRequestSchema;
    output: typeof ListApiKeysResponseSchema;
  },
  /**
   * @generated from rpc customer.management.v1.CustomerApiKeyService.CreateApiKey
   */
  createApiKey: {
    methodKind: "unary";
    input: typeof CreateApiKeyRequestSchema;
    output: typeof CreateApiKeyResponseSchema;
  },
  /**
   * @generated from rpc customer.management.v1.CustomerApiKeyService.DeleteApiKey
   */
  deleteApiKey: {
    methodKind: "unary";
    input: typeof DeleteApiKeyRequestSchema;
    output: typeof DeleteApiKeyResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_customer_management_v1_service, 1);

/**
 * for internal use
 *
 * @generated from service customer.management.v1.OrgManagementService
 */
export const OrgManagementService: GenService<{
  /**
   * @generated from rpc customer.management.v1.OrgManagementService.ListOrgs
   */
  listOrgs: {
    methodKind: "unary";
    input: typeof ListOrgsRequestSchema;
    output: typeof ListOrgsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_customer_management_v1_service, 2);

